<template>
    <div class="field">
        <label v-if="label" class="label">
            {{ label }}{{ hideLabelColon ? '' : ':' }}
            <span
                v-if="!hideRequired && required"
                class="label-type"
                :class="{
                    'is-required': required,
                }"
            >
                <span v-if="required">(required)</span>
            </span>
            <span>&nbsp;</span>
            <fa-icon
                v-if="tooltip"
                :tooltip="tooltip"
                icon="info-circle"
                class="configurationProfile__tooltip-icon"
            />
        </label>
        <div v-if="!hideUploader" class="control" :class="controlClass">
            <input
                ref="file"
                class="formUpload__input"
                type="file"
                name="files[]"
                multiple
                :accept="accept"
                @change="handleUpload"
            />
            <div
                ref="drag-n-drop"
                class="formUpload"
                :class="{
                    'formUpload--isDragging': dragging,
                }"
            >
                <div v-if="showNewDesign" class="formUpload__label">
                    <a @click="handleOpenFileSystem">Upload</a> or Drag and drop <br />
                    opt-in image of your choice.
                </div>
                <div v-else class="formUpload__label">
                    <a @click="handleOpenFileSystem">Choose a File</a> or<br />
                    Drag n' Drop
                </div>
            </div>
        </div>
        <p v-if="error" class="help has-text-danger" v-text="error" />
        <p v-if="warning" class="help has-text-warning" v-text="warning" />
    </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';

export default {
    props: {
        label: { type: String, default: '' },
        error: { type: String, default: '' },
        warning: { type: String, default: '' },
        required: { type: Boolean, default: false },
        hideRequired: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        tooltip: { type: [String, Object], default: '' },
        hideLabelColon: { type: Boolean, default: false },
        accept: {
            type: String,
            default: 'image/*,video/*,.pdf,.csv,.doc,.docx,.xls,.xlsx,.vcard,.vcf,.mp3,.wav,.wave',
        },
        showNewDesign: { type: Boolean, default: false },
        hideUploader: { type: Boolean, default: false },
    },

    emits: ['onChange'],

    data: () => ({
        dragging: false,
        draggedOver: false,
        droppedFiles: [],
    }),

    computed: {
        controlClass() {
            let classes = [];

            if (this.icon) {
                classes.push('has-icons-left');
            }

            if (this.error) {
                classes.push('is-danger');
            }

            return classes.join(' ');
        },
    },

    methods: {
        init() {
            this.initEvent();
        },

        remove() {
            this.droppedFiles = [];
            this.removeEvent();
        },

        initEvent() {
            const $elementDragInDrop = $(this.$refs['drag-n-drop']);
            const $elementBody = $('body');

            $elementBody.on('drag dragstart dragend dragover dragenter dragleave drop', (e) => {
                e.originalEvent.dataTransfer.effectAllowed = 'copy';
                e.originalEvent.dataTransfer.dropEffect = 'copy';

                e.preventDefault();
                e.stopPropagation();

                return e;
            });
            $elementBody.on('dragover dragenter', () => {
                this.dragging = true;
            });
            $elementBody.on('dragleave dragend drop', () => {
                this.dragging = false;
            });

            $elementDragInDrop.on('dragover dragenter', () => {
                this.dragging = true;
                this.draggedOver = true;
            });
            $elementDragInDrop.on('dragleave dragend drop', () => {
                this.draggedOver = false;
            });
            $elementDragInDrop.on('drop', (e) => {
                this.handleChange([...e.originalEvent.dataTransfer.files]);
            });
        },

        handleUpload(e) {
            this.handleChange([...e.target.files]);

            e.target.value = null;
        },

        removeEvent() {
            const $elementDragInDrop = $(this.$refs['drag-n-drop']);
            const $elementBody = $('body');

            $elementBody.off('drag dragstart dragend dragover dragenter dragleave drop');
            $elementDragInDrop.off('dragend dragover dragenter dragleave drop');
        },

        handleChange(files) {
            this.droppedFiles = files.map((file) => ({
                uuid: uuidv4(),
                file: file,
            }));

            this.$emit('onChange', this.droppedFiles);
        },

        handleOpenFileSystem(e) {
            e.stopPropagation();

            this.$refs.file.click();
        },
    },

    mounted() {
        this.init();
    },

    beforeUnmount() {
        this.remove();
    },
};
</script>

<style lang="scss" scoped>
@import './styles.module.scss';
</style>
